import { Route, Switch } from 'react-router-dom';

import useCurrentPath from 'common/hooks/useCurrentPath';

import OtherOption from './components/OtherOption';
import SatisfiedOptions from './components/SatisfiedOptions';
import UnsatisfiedOptions from './components/UnsatisfiedOptions';

const FormStepSatisfaction = () => {
  const { path } = useCurrentPath();

  return (
    <Switch>
      <Route component={UnsatisfiedOptions} path={`${path}/unsatisfied`} />
      <Route component={SatisfiedOptions} path={`${path}/satisfied`} />
      <Route component={OtherOption} path={`${path}/other`} />
    </Switch>
  );
};

export default FormStepSatisfaction;
